export default __webpack_public_path__ + "static/media/article.9cc3058d.svg";